import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import axios from 'axios';
import { RETRIEVE_SESSION_URL } from './retrieveSessionContent';
import httpClient from 'utils/httpClient';

const URL = process.env.REACT_APP_API_URI;

const SEND_HOMEWORK_FILE = (id: Number, courseId: number) =>
  `/v2/teacher/course/${courseId}/session/${id}/teacher-attachment-home-work`;

const SEND_HOMEWORK_VIDEO = (id: Number, courseId: number) =>
  `/v2/teacher/course/${courseId}/unit/${id}/teacher-unit-video`;

const SEND_HOMEWORK_FILE_SESSION = (id: Number, courseId: number) =>
  `/v2/teacher/course/${courseId}/session/${id}/teacher-attachment-home-work`;
const token = localStorage.getItem('token');
export type SendHomeworkFileBody = {
  id: number;
  formData: FormData;
  courseId: number;
  onProgress?: (progress: number) => void;
};

export type SendHomeworkFileResponse = {
  _data: {
    homeWork: {
      // eslint-disable-next-line camelcase
      section_id: number;
    };
  };
};

export const sendHomeworkFile = ({
  id,
  courseId,
  formData,
}: SendHomeworkFileBody) => {
  return httpClient.post<SendHomeworkFileResponse>(
    SEND_HOMEWORK_FILE(id, courseId),
    formData,
    {
      headers: {
        ContentType:
          'multipart/form-data; boundary=----WebKitFormBoundaryRrouvXOkU01wCDJt',
      },
    },
  );
};

export const useSendHomeworkFile = (
  opts?: UseMutationOptions<
    AxiosResponse<SendHomeworkFileResponse>,
    AxiosError<any>,
    SendHomeworkFileBody
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse<SendHomeworkFileResponse>,
    AxiosError<any>,
    SendHomeworkFileBody
  >(sendHomeworkFile, {
    ...opts,
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(
        // eslint-disable-next-line no-underscore-dangle
        RETRIEVE_SESSION_URL(id),
      );
    },
  });
};
export const sendHomeworkVideo = async ({
  id,
  courseId,
  formData,
  onProgress, // Nhận callback onProgress
}: SendHomeworkFileBody): Promise<AxiosResponse<SendHomeworkFileResponse>> => {
  const fullUrl = `${URL}${SEND_HOMEWORK_VIDEO(id, courseId)}`;

  try {
    return await axios.post<SendHomeworkFileResponse>(fullUrl, formData, {
      headers: {
        ContentType:
          'multipart/form-data; boundary=----WebKitFormBoundaryRrouvXOkU01wCDJt',
        Authorization: `Bearer ${token}`,
      },
      timeout: 7200000,
      onUploadProgress: progressEvent => {
        if (progressEvent.total && onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          onProgress(percentCompleted);
        }
      },
    });
  } catch (error) {
    console.error('Error sending homework video:', error);
    throw error;
  }
};

export const useSendHomeworkVideo = (
  opts?: UseMutationOptions<
    AxiosResponse<SendHomeworkFileResponse>,
    AxiosError<any>,
    SendHomeworkFileBody
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation<
    AxiosResponse<SendHomeworkFileResponse>,
    AxiosError<any>,
    SendHomeworkFileBody
  >(sendHomeworkVideo, {
    ...opts,
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries(
        // eslint-disable-next-line no-underscore-dangle
        RETRIEVE_SESSION_URL(id),
      );
    },
  });
};
